import { __awaiter, __generator } from "tslib";
import { FileType } from '@office-start/document-types';
import React, { useCallback, useMemo } from 'react';
import styles from '../EdgeworthItemControl.module.scss';
//TODO: put styles in DocumentControl.module.scss
/**
 * @param item - Document
 * @param onAttributionClick - Click handler for the breadcrumb
 * @returns Shared component business logic for the breadcrumb (or attribution) of a document
 */
export function Breadcrumb(props) {
    var _this = this;
    var handleIsNavigableMouseClick = useCallback(function (event) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (props.onAttributionClick) {
                props.onAttributionClick(event);
            }
            return [2 /*return*/];
        });
    }); }, [props]);
    var _a = useMemo(function () {
        var _a, _b;
        if (props.item.fileType === FileType.MeetingObject) {
            return {
                attributionString: props.transformToDateTimeString(props.item.createdDate, false, undefined, false, true),
                isNavigable: false,
            };
        }
        else {
            return {
                attributionString: props.item.isEmailAttachment ||
                    (!props.item.attribution &&
                        ((_a = props.item.emailReference) === null || _a === void 0 ? void 0 : _a.Subject))
                    ? (_b = props.item.emailReference) === null || _b === void 0 ? void 0 : _b.Subject
                    : props.item.attribution,
                isNavigable: !!props.item.attributionUrl,
            };
        }
    }, [props]), attributionString = _a.attributionString, isNavigable = _a.isNavigable;
    return (React.createElement(React.Fragment, null, isNavigable ? (React.createElement("div", { className: styles['accessible-attribution'], onClick: handleIsNavigableMouseClick }, attributionString)) : (React.createElement("span", null, attributionString))));
}
//# sourceMappingURL=Breadcrumb.js.map